import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CurrencyFormattingService {
    /**
     * Formats a number as USD currency.
     *
     * @param amount The amount to format.
     * @returns The formatted currency string.
     */
    formatToUSD(amount: number): string {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(amount);
    }
}
